





























































































































































































































































































































import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import {
  ContactDTO,
  CountryDTO,
  AddressShipmentDTO
} from "../../../model/data.model";
import {
  GetContactResults,
  ContactListItem,
  IPagination
} from "../../../model/component.model";
import { TranslatedCountryDTO } from "../../../model/component.model";
import { ContactService } from "../../../services/ContactService";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import Pagination from "../../shared/Pagination.vue";
import Accordion from "@/components/shared/Accordion.vue";
import i18n from "@/lang/i18n";
import store from "@/vuex/store";
import { ElTable } from "element-ui/types/table";
import { fieldSorter } from "@/services/Helpers";
import { SearchExport } from "../../shared/SearchExport";
import addressDisplay from "@/filters/AddressFilter";
import { format } from "date-fns";

@Component({
  components: {
    Pagination: Pagination,
    Accordion: Accordion
  }
})
export default class ContactsSearch extends Vue {
  @Inject() contactService: ContactService;
  @Prop() showSelectors: boolean;
  @Prop() receiverData: AddressShipmentDTO;
  @Prop() typeAddressPickup: number;
  @Prop({ default: false }) fromNewShipment: boolean;

  userLogged = this.$store.getters.user.username as string;
  contacts: ContactListItem[] = [];
  countries: any = [];
  sort: string[] = [];
  country = {
    countryCode: "",
    countryLoyaltyId: 0,
    id: "",
    name: "",
    translatedName: String(i18n.t("country"))
  } as CountryDTO;
  searchParams: any = {
    zipCode: "",
    city: "",
    address: "",
    province: "",
    search: "",
    tradename: "",
    orderField: "",
    orderDirection: "asc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25,
    countryId: "",
    addressType: "",
    molUsername: this.userLogged,
    addressNickname: ""
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  contactsSelected: ContactListItem[] = [];
  searchExport: SearchExport = new SearchExport();

  $refs!: {
    contactTable: ElTable;
  };

  async created() {
    await store.cache
      .dispatch("cachemod/getCountries")
      .then((countries: CountryDTO[]) => {
        countries.sort((a: CountryDTO, b: CountryDTO) =>
          a.name < b.name ? -1 : 1
        );
        this.countries = countries
          .map(
            (country: CountryDTO): TranslatedCountryDTO => {
              const translatedCountry = { ...country } as TranslatedCountryDTO;
              translatedCountry.translatedName = this.$t(
                "country_" + country.id
              ).toString();
              return translatedCountry;
            }
          )
          .sort(fieldSorter(["translatedName"]));
      })
      .catch(() => {
        this.$snotify.error(this.$t("error_getting_countries").toString());
      });
    this.contacts = [];
    if (this.receiverData && Object.keys(this.receiverData).length) {
      this.loadReceiverPreset();
    }
    this.search(this.typeAddressPickup);
  }
  loadReceiverPreset() {
    this.searchParams.search = this.receiverData.contact;
    this.searchParams.address = this.receiverData.address;
    this.searchParams.zipCode = this.receiverData.zipCode;
    this.searchParams.city = this.receiverData.city;
    this.searchParams.province = this.receiverData.province;
    this.searchParams.tradename = this.receiverData.companyName;
    this.searchParams.addressNickname = this.receiverData.addressNickname;
  }
  resetFilters() {
    this.searchParams = {
      zipCode: "",
      city: "",
      address: "",
      province: "",
      search: "",
      tradename: "",
      orderField: "",
      orderDirection: "asc",
      totalElements: 0,
      totalPages: 0,
      numberOfElements: 0,
      page: 0,
      sort: ",asc",
      pageSize: 25,
      countryId: "",
      addressNickname: ""
    };
    this.country = {
      countryCode: 0,
      countryLoyaltyId: 0,
      id: "",
      name: "",
      translatedName: String(i18n.t("country"))
    } as CountryDTO;
    this.search(this.typeAddressPickup);
  }

  search(typeAddressPickup: number) {
    this.searchParams.molUsername = this.userLogged;
    // Ensure that selectAll radio checkbox is deselected
    if (this.contactsSelected.length > 0) {
      this.selectAll(false);
    }

    this.contacts = [];
    if (this.typeAddressPickup == 1) {
      this.searchParams.addressType = "SHIPMENT";
    } else if (this.typeAddressPickup == 2) {
      this.searchParams.addressType = "OPERATION";
    }
    this.searchParams.fromNewShipment = this.fromNewShipment;
    this.contactService
      .getContacts(this.searchParams)
      .then((res: GetContactResults) => {
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;
        if (
          this.fromNewShipment &&
          res.contacts.length == 1 &&
          res.contacts[0].addressNickname &&
          res.contacts[0].addressNickname.toLowerCase() ==
            this.searchParams.tradename.toLowerCase()
        ) {
          const o: ContactListItem = {
            ...(res.contacts[0] as ContactListItem)
          };
          o.selected = false;
          this.contacts.push(o);
          this.contactClicked(o);
        } else {
          this.contacts = [];
          res.contacts.forEach((item: ContactDTO) => {
            const o: ContactListItem = { ...(item as ContactListItem) };
            o.selected = false;
            this.contacts.push(o);
          });
        }
        this.fromNewShipment = false;
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  @Watch("typeAddressPickup")
  searchResult() {
    this.search(this.typeAddressPickup);
  }

  @Watch("searchParams.sort") changeSortField() {
    this.search(this.typeAddressPickup);
  }
  @Watch("searchParams.direction") changeSortDirection() {
    this.search(this.typeAddressPickup);
  }

  countryModified(item: CountryDTO) {
    this.searchParams.countryId = item.id;
    this.$emit("countryModified");
  }

  sortTable(field: string, direction: string) {
    this.searchParams.orderField = field;
    this.searchParams.orderDirection = direction;
  }

  selectAll(value: boolean) {
    if (value) {
      this.$refs.contactTable.toggleAllSelection();
    } else {
      this.$refs.contactTable.clearSelection();
    }
  }

  handleSelectionChange(val: any[]) {
    this.contactsSelected = val;
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search(this.typeAddressPickup);
  }

  contactClicked(contact: ContactDTO) {
    this.$emit("contactSelected", [contact, contact.addresses[0]]);
  }

  getContactEmail(contact: ContactListItem) {
    return AddressShipmentDTO.extractContact(
      contact.contactsReference,
      "EMAIL1"
    )?.value;
  }

  getContactName(contact: ContactListItem) {
    return AddressShipmentDTO.extractContact(
      contact.contactsReference,
      "CONTACT_NAME"
    )?.value;
  }

  getContactTelephone(contact: ContactListItem) {
    return AddressShipmentDTO.extractContact(
      contact.contactsReference,
      "TELEPHONE1"
    )?.value;
  }

  getContactNickname(contact: ContactListItem) {
    return AddressShipmentDTO.extractContact(
      contact.contactsReference,
      "NICKNAME"
    )?.value;
  }

  confirmDeletion() {
    AlertBus.$alerts
      .confirm(this.$t("delete_contacts_title"))
      .then((val: boolean) => {
        if (val) {
          this.deleteSelectedContacts();
        }
      });
  }
  sortChange(event: any) {
    this.searchParams.orderField = "firstname";
    if (event.order === "descending") {
      this.searchParams.orderDirection = "desc";
    } else if (event.order === "ascending") {
      this.searchParams.orderDirection = "asc";
    } else {
      this.searchParams.orderDirection = "asc";
    }
    this.search(this.typeAddressPickup);
  }

  deleteSelectedContacts() {
    const contacts_to_delete: any = [];
    this.contactsSelected.forEach((sel: any) => {
      contacts_to_delete.push(sel.id);
    });
    this.contactService.deleteContacts(contacts_to_delete).then(() => {
      this.search(this.typeAddressPickup);
    });
  }

  async exportAll() {
    const total = this.searchParams.totalElements || 0;
    if (total === 0) {
      this.$snotify.info(this.$t("no_elements").toString());
      return;
    }
    const maxExport = 2000;
    const params = {
      ...this.searchParams,
      page: 0,
      pageSize: Math.min(total, maxExport),
      molUsername: this.userLogged,
      fromNewShipment: false
    };
    try {
      const res: GetContactResults = await this.contactService.getContacts(
        params
      );
      const rows = (res.contacts as ContactListItem[]).map(
        (c: ContactListItem) => ({
          [this.$t("business_name").toString()]: `${c.firstname ||
            ""} ${c.lastname || ""}`.trim(),
          [this.$t("addressNickname").toString()]: c.addressNickname || "",
          [this.$t("main_address").toString()]:
            c.addresses && c.addresses[0] ? addressDisplay(c.addresses[0]) : "",
          [this.$t("email").toString()]: this.getContactEmail(c) || "",
          [this.$t("contact_name").toString()]: this.getContactName(c) || "",
          [this.$t("telephone").toString()]: this.getContactTelephone(c) || ""
        })
      );
      const filename = `export_${format(new Date(), "yyyy-MM-dd_HHmm")}.xlsx`;
      this.searchExport.exportToXlsx(filename, rows);
    } catch (e) {
      this.$snotify.error(this.$t("export_error").toString());
    }
  }

  duplicateContact() {
    const contact = this.contactsSelected[0] as any;
    delete contact.id;
    contact.contactsReference.map((item: any) => {
      delete item.id;
      delete item.entityId;
      delete item.entityType;
    });
    contact.addresses.map((item: any) => {
      delete item.id;
      delete item.entityId;
      delete item.entityType;
    });
    this.contactService.saveContact(contact as ContactDTO).then(() => {
      this.search(this.typeAddressPickup);
    });
  }
}
